import Schema from "../model/schema";
import SchemaObject from "../model/schemaObject";

export default function isSchemaObject(object: Schema): object is SchemaObject {
    return "properties" in object;
}
